import { useParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';

import { DocumentDetailView } from '@/components/documents/DocumentDetailView';
import { useDocumentDetail } from '@/hooks/use-documents';

export default function DocumentDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: aiResults, isLoading, isError } = useDocumentDetail(id ?? '');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isError || !aiResults) {
    return (
      <div className="flex flex-col items-center justify-center py-12 gap-2">
        <AlertCircle className="h-6 w-6 text-destructive" />
        <p className="text-sm text-destructive">
          Document not found or failed to load.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Document Detail</h1>
      <DocumentDetailView aiResults={aiResults} />
    </div>
  );
}
